import React from 'react';
import classnames from 'classnames';

import Button from '@wix/da-shared-react/pkg/Button';

import s from './EmptyState.scss';

export interface Props {
  className?: string;
  titleClassName?: string;
  title?: string;
  subtitle?: string | JSX.Element;
  view?: 'large' | 'small' | 'wide';
  withButton?: boolean;
  buttonLabel?: string;
  onButtonClick?: () => void;
}
export class EmptyState extends React.Component<Props> {
  render() {
    const {
      className,
      titleClassName,
      view = 'large',
      title,
      subtitle,
      withButton,
      buttonLabel,
      onButtonClick,
    } = this.props;

    return (
      <div
        className={classnames(
          s['root'],
          s[view],
          withButton && s['with-button'],
          className
        )}
      >
        <div className={s['title-wrapper']}>
          <div className={classnames(s['title'], titleClassName)}>{title}</div>
          <div className={s['subtitle']}>{subtitle}</div>
          {withButton && onButtonClick && (
            <Button
              view="b16-undisciplined-designers"
              onClick={onButtonClick}
              className={s['button']}
            >
              {buttonLabel}
            </Button>
          )}
        </div>
      </div>
    );
  }
}

export default EmptyState;
